import type { UIStringsOverride } from "../i18n-ui.ts";

/** Turkish (tr) UI strings. */
export const tr: UIStringsOverride = {
  actions: {
    addToCursor: "Cursor'a ekle",
    addToVscode: "VS Code'a ekle",
    askAI: "Bu sayfa hakkında yapay zekâya sor",
    connectMcp: "MCP'ye bağlan",
    copied: "Kopyalandı!",
    copyClaudeCode: "Claude Code komutunu kopyala",
    copyCode: "Kodu kopyala",
    copyCodex: "Codex komutunu kopyala",
    copyMarkdown: "Markdown olarak kopyala",
    copyServerUrl: "Sunucu URL'sini kopyala",
    edit: "GitHub'da düzenle",
    export: "Dışa aktar",
    exportEpub: "EPUB olarak dışa aktar",
    exportPdf: "PDF olarak dışa aktar",
    generating: "Oluşturuluyor…",
    openIn: "{name} içinde aç",
    openInChat: "Sohbette aç",
    scrollToTop: "Başa dön",
  },
  ask: {
    ai: "Yapay zekâ",
    clear: "Konuşmayı temizle",
    close: "Kapat",
    copy: "Konuşmayı kopyala",
    empty: "Belgeler hakkında bir soru sorun.",
    error: "Üzgünüz, bir şeyler ters gitti.",
    label: "Bir soru sorun",
    placeholder: "Bir soru sorun…",
    send: "Gönder",
    tip: "İpucu: Sohbeti şu tuşla açıp kapatabilirsiniz:",
    title: "Yapay zekâya sor",
    you: "Siz",
  },
  banner: { dismiss: "Duyuruyu kapat" },
  changelog: {
    description: "Ürün güncellemeleri ve sürüm notları.",
    showReleases: "{version} sürümlerini göster",
    title: "Değişiklik günlüğü",
  },
  content: { diagramError: "Bu diyagram görüntülenemedi." },
  feedback: {
    no: "Hayır",
    question: "Bu sayfa yardımcı oldu mu?",
    thanks: "Geri bildiriminiz için teşekkürler!",
    yes: "Evet",
  },
  languageSwitcher: { label: "Dil", untranslated: "Çevrilmemiş" },
  nav: {
    back: "Geri",
    breadcrumb: "Gezinme yolu",
    closeNavigation: "Gezinmeyi kapat",
    deprecated: "kullanımdan kaldırıldı",
    featured: "Öne çıkan",
    githubRepository: "GitHub deposu",
    navigation: "Gezinme",
    primary: "Birincil",
    sections: "Bölümler",
    toggleNavigation: "Gezinmeyi aç/kapat",
    toggleTheme: "Renk temasını değiştir",
  },
  notFound: {
    description: "Aradığınız sayfayı bulamadık.",
    home: "Ana sayfaya dön",
    title: "Sayfa bulunamadı",
  },
  page: {
    lastUpdated: "Son güncelleme",
    next: "Sonraki",
    pagination: "Sayfalama",
    previous: "Önceki",
    skipToContent: "İçeriğe geç",
  },
  search: {
    all: "Tümü",
    allLanguages: "Tüm diller",
    askAi: "Yapay zekâya sor",
    askAiHint: "Yapay zekâdan anında yanıt alın",
    button: "Ara",
    devOnly: "Arama, üretim derlemesinde kullanılabilir.",
    error: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
    label: "Belgelerde ara",
    navigate: "gezin",
    noResults: "Sonuç bulunamadı.",
    open: "aç",
    placeholder: "Belgelerde ara…",
    popular: "Popüler",
    preview: "önizle",
    results: "Sonuçlar",
  },
  toc: { title: "Bu sayfada" },
};
